import React, { PureComponent as Component, useState, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Button, Collapse, Table } from "reactstrap";
import styled from "styled-components";
import propTypes from "prop-types";
import classnames from "classnames";
import _ from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom"
import ProtectedButton from '../../../../../Forms/ProtectedButton';

// IMPORT HELPERS
import { TextRupiah } from "../../../../../Text";
import { estimatedTimeArrivals } from "../../../../../../utils/Helpers";
import { useEtaText } from "../../../../../../helpers/dom";

// IMPORT COMPONENT
import SizeItem from "./SizeItem";

// IMPORT MODAL
import ModalProductDefect from "../../../../../Modals/ModalProductDefect";

// IMPORT ASSETS
import PreVerified from "../../../../../../images/pre-verified30.png";
import isDefect from "../../../../../../images/is-defect.png";
import KaFair from "../../../../../../images/ka_fair.png";
import Novembazaar from "../../../../../../images/novembazaar_logo.png";
import PreVerifiedUnderRetail from "../../../../../../images/preverified_disc.png";

const SizeGridList = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.isEmpty ? "1fr" : "repeat(8, 1fr)"};
  grid-gap: 1rem;
  margin-top: 1rem;
  > .size-grid__item .size-grid__item__wrapper {
    position: relative;
    .btn {
      background-color: transparent;
      padding: 6px 0;
      font-size: 0.75rem;
      color: #979797;
      font-family: "Montserrat Light", "Century Gothic", Helvetica, Arial;
      border: none;
      cursor: pointer;
      text-align: center;
      border: 1px solid #d8d8d8;
      width: 50px;
      max-width: 50px;
      border-radius: 0;
      &.selected,
      &:active,
      &:focus,
      &:hover {
        font-family: "Montserrat Bold", "Century Gothic Bold";
        background-color: #4a4a4a;
        color: #fff;
        border: 0;
      }
    }
    .size-grid__item__preverified {
      position: absolute;
      width: 20px;
      left: 33px;
      top: -10px;
      img {
        width: 100%;
        max-width: 100%;
      }
    }
  }
  > .not-available {
    margin-top: 15px;
    display: flex;
    justify-content: center;
  }
  @media (max-width: 1024px) {
    grid-template-columns: ${(props) =>
    props.isEmpty ? "1fr" : "repeat(auto-fill, minmax(50px, 1fr))"};
  }
`;

const PreverifiedIcon = ({ isEventActive, fromUnderRetail }) => (
  <KickImage src={fromUnderRetail > 0 ? PreVerifiedUnderRetail : isEventActive ? KaFair : PreVerified} />
);

const SizeGridItem = (props) => {
  /* DECONSTRUCT PROPS */
  const {
    defects,
    isVilla,
    size,
    category,
    missing_accessories,
    sneaker_defect,
    onSizeSelected,
    sell,
    active,
    total_subsidy,
    box_condition,
    asking_price,
    yellowing,
    display_item,
    isHandbag,
    isEventActive,
    pre_verified,
    highest_bid,
    hide_box_info,
    note,
    isCollapse,
    isVintage,
    buttonBuyOffer,
    handleCurrentPage,
    isLastSize,
    dataAuth,
    history,
    showPreverifiedInfoHandler,
    showHotProductInfoHandler,
    isFromUnderRetail,
    isOnlyKickPoint
  } = props;

  const isPrever = pre_verified ? true : false
  const isHotProduct = sell.subsidy_price ? true : false
  const [etaTextObject] = useEtaText()

  // useEffect(() => {
  showPreverifiedInfoHandler(isPrever)
  showHotProductInfoHandler(isHotProduct)
  // }, [])

  const uniqueDefects = _.uniqBy(defects, "name");

  const dustBagDefects = uniqueDefects
    ? uniqueDefects.find((a) => a.name === "DUST_BAG") || {}
    : {};
  const boxHandbagDefects = uniqueDefects
    ? uniqueDefects.find((a) => a.name === "BOX") || {}
    : {};

  const isSneakers = isVilla && category === "sneakers";
  const isApparels = isVilla && category === "apparels";
  const sneakerSize = size.cm === undefined ? "" : size.cm;
  const apparelSize = size.US === undefined ? "" : size.US;

  const additionalCondition = defects.length
    ? `(${defects.map((d) => d.display_name).join(", ")})`
    : "";
  const luxuryDetailArr = [
    missingAcc(missing_accessories),
    dustBag(dustBagDefects.value),
    boxHandbag(boxHandbagDefects && boxHandbagDefects.value),
    sneaker_defect ? handbagCondition(uniqueDefects) : "",
  ];
  const luxuryDetail = luxuryDetailArr
    .filter((item) => item !== "" && item !== "Missing Box")
    .map((item) => item)
    .join(", ");

  const etaText = estimatedTimeArrivals(pre_verified, isEventActive, isCollapse, etaTextObject)

  const sizeForDesc = (() => {
    if (category === "handbags" || category === "lifestyles") {
      return apparelSize === "All Size"
        // ? `${isHandbag && isHandbag.toLowerCase()} ${apparelSize}`
        ? apparelSize
        : isHandbag ? `${isHandbag && isHandbag.toLowerCase()}` : apparelSize;
    } else if (isSneakers) {
      return sneakerSize;
    } else {
      return apparelSize;
    }
  })();

  const buyNowPrice =
    total_subsidy && parseInt(total_subsidy) > 0 ? total_subsidy : asking_price;

  const dataForDescriptionSection = {
    isCollapse,
    etaText,
    sizeForDesc,
    pre_verified,
    buyNowPrice,
    highestOffer: highest_bid,
    isCollapse,
    ...props,
  };

  //PRODUCT DEFECT HANDLER
  const [isOpen, setIsOpen] = useState(false);

  const handleRedirectUrl = (status) => {
    switch (status) {
      case "login":
        history.push({
          pathname: '/login',
          state: { isFromProductDetail: true, redirectPath: history.location.pathname, redirectSearch: history.location.search, selectedCondition: isCollapse }
        })
        break;
    }
  }

  return (
    <tr className={`${isLastSize ? "border-bottom" : ""}`}>
      <ProtectedButton
        onClick={() => {
          handleCurrentPage("3", { ...dataForDescriptionSection, status: "buy-now" });
          onSizeSelected(sell);
        }}
        isLogged={dataAuth.isLogged}
        userData={dataAuth.userdata}
        roleNotAlloweds={['unverified_user']}
        disabled={false}
        childrenFunc={props => {
          return (
            <td onClick={() => {
              props.status ? handleRedirectUrl(props.status) : props.onClick()
            }}>
              {total_subsidy && parseInt(total_subsidy) > 0 ? (
                <TextRupiah
                  value={total_subsidy}
                  prefix="IDR "
                  className="price-tag"
                  color="red"
                  align="center"
                  bold={true}
                  isSubsidy
                  isOnlyKickPoint={isOnlyKickPoint}
                />
              ) : (
                <TextRupiah
                  value={asking_price}
                  prefix="IDR "
                  className="price-tag"
                  color="black"
                  align="center"
                  bold={true}
                  isOnlyKickPoint={isOnlyKickPoint}
                />
              )}
            </td>
          )
        }}
      />
      <ProtectedButton
        onClick={() => {
          handleCurrentPage("3", { ...dataForDescriptionSection, status: "buy-now" });
          onSizeSelected(sell);
        }}
        isLogged={dataAuth.isLogged}
        userData={dataAuth.userdata}
        roleNotAlloweds={['unverified_user']}
        disabled={false}
        childrenFunc={props => {
          return (
            <td
              onClick={() => {
                props.status ? handleRedirectUrl(props.status) : props.onClick()
              }}
              className="middle-table"
            >
              <div xs={1} className="second-child defect-product-icon">
                {box_condition !== "SEMPURNA" ||
                  missing_accessories ||
                  yellowing ||
                  sneaker_defect ||
                  display_item ? (
                  <div
                    onClick={() => {
                      setIsOpen(!isOpen);
                    }}
                    className="defect-icon-wrapper"
                  >
                    <KickImage src={isDefect} alt="..." />
                    {/* <ModalProductDefect
                      isOpen={isOpen}
                      toggle={() => setIsOpen(!isOpen)}
                      dataProduct={props}
                    /> */}
                  </div>
                ) : null}
              </div>
              {category === "handbags" || category === "lifestyles" ? (
                <div sm={2} xs={2} className="size-div-tabel fourth-child">
                  {apparelSize !== "All Size" ? (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {isHandbag && isHandbag.toLowerCase()}
                      </span>
                      <span style={{ fontSize: "1rem" }}>{apparelSize}</span>
                    </div>
                  ) : (
                    <span style={{ textTransform: "capitalize" }}>
                      {/* {isHandbag && isHandbag.toLowerCase()} */}
                      {apparelSize}
                    </span>
                  )}
                </div>
              ) : isSneakers ? (
                <div sm={2} xs={2} className="size-div-tabel third-child">
                  <span>{sneakerSize}</span>
                </div>
              ) : (
                <div sm={2} xs={2} className="size-div-tabel third-child">
                  <span>{apparelSize}</span>
                </div>
              )}
              <div
                xs={1}
                className={classnames("second-child preveriviedicon", {
                  preverified: !isEventActive,
                })}
              >
                {pre_verified ? (
                  <PreverifiedIcon isEventActive={isEventActive} fromUnderRetail={isFromUnderRetail} />
                ) : null}
              </div>
            </td>
          )
        }}
      />
      <ProtectedButton
        onClick={() => {
          let status = "offer-now"
          if (dataAuth.isLogged && dataAuth.userdata?.country_code) {
            const countryId = dataAuth.userdata.country_code
            if (countryId !== 'IDN') {
              status = "buy-now"
            }
          }
          handleCurrentPage("3", { ...dataForDescriptionSection, status });
          onSizeSelected(sell);
        }}
        isLogged={dataAuth.isLogged}
        userData={dataAuth.userdata}
        roleNotAlloweds={['unverified_user']}
        disabled={false}
        childrenFunc={props => {
          return (
            <td onClick={() => {
              props.status ? handleRedirectUrl(props.status) : props.onClick()
            }}>
              {highest_bid ? (
                <TextRupiah
                  value={highest_bid}
                  prefix="IDR. "
                  align="center"
                  subsidy={parseInt(total_subsidy) > 0}
                  isOffer
                  isOnlyKickPoint={isOnlyKickPoint}
                />
              ) : (
                <p className="no-offer">-</p>
              )}
            </td>
          )
        }}
      />
    </tr>
  );
};

const defectCondition = (bool, data) => {
  switch (bool) {
    case true:
      return detailCondition(data);
    case false:
      return <span>Perfect Condition</span>;

    default:
      return <span>Perfect Condition</span>;
  }
};

const detailCondition = (data) => {
  const str = data
    .filter((item) => item.value)
    .map((item) => item.display_name)
    .join(", ");

  return str;
};

const handbagCondition = (data) => {
  return detailHandbag(data);
};

const detailHandbag = (data) => {
  const str = data
    .filter((item) => item.value)
    .map((item) => item.display_name)
    .join(", ");

  return str;
};

const dustBag = (condition) => {
  if (condition === true) {
    return "";
  } else {
    return "KA Dust Bag";
  }
};

const boxHandbag = (condition) => {
  if (condition === true) {
    return "";
  } else {
    return "Missing Box";
  }
};

const missingAcc = (condition) => {
  if (condition === true) {
    return "Missing Accessories";
  } else {
    return "Complete Accessories";
  }
};

SizeGridItem.defaultProps = {
  box_condition: "SEMPURNA",
  yellowing: false,
  missing_accessories: false,
  sneaker_defect: false,
  display_item: false,
  pre_verified: false,
  pre_order: false,
  isOnlyKickPoint: false
};

const sortingOption = (isVilla) => {
  const sizeType = isVilla ? "cm" : "US";

  return (a, b) => {
    return parseFloat(a.size[sizeType]) !== parseFloat(b.size[sizeType])
      ? parseFloat(a.size[sizeType]) - parseFloat(b.size[sizeType])
      : (a.size[sizeType] > b.size[sizeType]) -
      (a.size[sizeType] < b.size[sizeType]);
  };
};

class SizeListV3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolled: false,
    };
    this.scrollTriggered = this.scrollTriggered.bind(this);
  }

  scrollTriggered() {
    let elmnt = document.getElementById("size-parent");
    let y = elmnt.scrollTop;

    if (y === 0) {
      this.setState({
        scrolled: false,
      });
    } else {
      this.setState({
        scrolled: true,
      });
    }
  }

  handbagCondition(sneaker_condition) {
    switch (sneaker_condition) {
      case "BARU":
        return "";
      case "PRISTINE":
        return "PRISTINE";
      case "GOOD":
        return "GOOD";
      case "WELL_USED":
        return "WELL USED";
      case "LIKE_NEW":
        return "LIKE NEW";
      case "VINTAGE":
        return "VINTAGE";
      default:
        return "";
    }
  }

  render() {
    /* DECONSTRUCT PROPS */
    const {
      isVilla,
      isCollapse,
      selected,
      handleSizeSelected,
      buttonBuyOffer,
      category,
      isKickFairActive,
      data = [],
      handleCurrentPage,
      dataAuth,
      isWomen,
      showPreverifiedInfoHandler,
      showHotProductInfoHandler,
      isOnlyKickPoint
    } = this.props;
    const objSize = {
      size: {
        US: 888,
        id: 999,
      },
      pre_verified: 0,
      sneakers_condition: "BARU",
    };
    const minusSize = 5 - (data.length % 5);
    const sizesFix = [];
    for (let i = 0; i < minusSize; i++) {
      sizesFix.push(objSize);
    }

    const finalSizes = [...data, ...sizesFix];
    let sortedFinalSizes = finalSizes.sort(sortingOption(isVilla));
    let sortedData = data.sort(sortingOption(isVilla));

    return (
      <div
        id="size-parent"
        className={classnames("size-grid__container collapse-transition", {
          scroll: this.state.scrolled === true,
        })}
        onScroll={this.scrollTriggered}
      >
        {data.length > 0 ? (
          <Table>
            <thead>
              <tr>
                <th>
                  <p>Price</p>
                </th>
                <th>
                  {
                    (category?.name === "handbags" || category?.name === "lifestyles") ? null : category.name === "apparels" ? <p>Size</p> : <p>US Size</p>
                  }
                </th>
                <th>
                  <p>Highest Offer</p>
                </th>
              </tr>
            </thead>
            <tbody className={isCollapse === "PO" ? "pre-order" : ""}>
              <div className="list-scroll-container">
                {data.map((item, index) => {
                  return (
                    <SizeGridItem
                      active={selected === item}
                      onSizeSelected={handleSizeSelected}
                      sell={item}
                      size={item.size}
                      asking_price={item.asking_price ? item.asking_price : 0}
                      highest_bid={item.highest_bid ? item.highest_bid.amount : 0}
                      missing_accessories={item.missing_accessories}
                      box_condition={item.box_condition}
                      yellowing={item.yellowing}
                      sneaker_defect={item.sneakers_defect}
                      display_item={item.display_item}
                      key={index}
                      isVilla={isVilla}
                      pre_verified={item.pre_verified}
                      isCollapse={isCollapse}
                      buttonBuyOffer={buttonBuyOffer}
                      defects={item.defects}
                      isHandbag={this.handbagCondition(item.sneakers_condition)}
                      note={item.note}
                      isEventActive={isKickFairActive}
                      total_subsidy={item.total_subsidy}
                      hide_box_info={item.product_variant.hide_box_info}
                      category={category.name}
                      isVintage={item.product_variant.vintage}
                      handleCurrentPage={handleCurrentPage}
                      item={item}
                      isLastSize={index === data.length - 1 ? true : false}
                      dataAuth={dataAuth}
                      history={this.props.history}
                      showPreverifiedInfoHandler={showPreverifiedInfoHandler}
                      showHotProductInfoHandler={showHotProductInfoHandler}
                      isFromUnderRetail={this.props.location && this.props.location.search.indexOf("product=under-retail")}
                      isOnlyKickPoint={isOnlyKickPoint}
                    />
                  );
                })}
              </div>
            </tbody>
          </Table>
        ) : (
          <div className="not-available">
            <h6 className="text-danger text-center">
              Sorry, no sizes available
            </h6>
          </div>
        )}
      </div>
    );
  }
}
SizeListV3.propTypes = {
  data: propTypes.array,
  selected: propTypes.object,
  handleSizeSelected: propTypes.func,
};
SizeListV3.defaultProps = {
  data: [],
  selected: null,
};

const mapStateToProps = (state) => ({
  isKickFairActive: state.dataKaFair.isKickFairActive,
  dataAuth: state.dataAuth,
});

export default connect(mapStateToProps, null)(withRouter(SizeListV3));
